import axios from '@axios'

const PREFIX = '/servicos'

export default {

  getServicosResumidos(filtro, cacheBust = null) {
    const url = cacheBust
      ? `${PREFIX}/resumido?_=${cacheBust}`
      : `${PREFIX}/resumido`
    return axios.post(url, filtro)
  },

  getServicosTributacaoAtividade(tributacaoId, atividadeId, filtro) {
    return axios.post(`${PREFIX}/tributacao-atividade?tributacaoId=${tributacaoId}&atividadeId=${atividadeId}`, filtro)
  },

  getServicos(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  getServico(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  updateServico(id, equipe) {
    return axios.put(`${PREFIX}/${id}`, equipe)
  },

  createServico(equipe) {
    return axios.post(`${PREFIX}/add`, equipe)
  },

  deleteServico(id, inativar) {
    return axios.delete(`${PREFIX}/${id}?inativar=${inativar}`)
  },

  deleteAll(idList) {
    return axios.delete(`${PREFIX}/lote`, { data: idList })
  },

  getHistoricosReajuste(servicoId) {
    return axios.get(`${PREFIX}/historicos/${servicoId}`)
  },

  existeVinculoPacoteAtivo(servicoId) {
    return axios.post(`${PREFIX}/vinculo-ativo?id=${servicoId}`)
  },

  verificaVinculo(id) {
    return axios.post(`${PREFIX}/vinculo?id=${id}`)
  },

  listaServicosOmie(simplesNacional) {
    return axios.get(`${PREFIX}/servicos-omie?simplesNacional=${simplesNacional}`)
  },

  exportarServicos() {
    return axios.get(`${PREFIX}/relatorio`, {
      responseType: 'blob',
    })
  },
}
